import { AutoCompleteItemProps } from './types';

export const AutoCompleteSelectItem = ({ option, onSelectItem, isHighlighted, isActive }: AutoCompleteItemProps) => {
  return (
    <li
      data-testid={`auto-complete-select-item-${option.label}`}
      onClick={onSelectItem}
      className={`py-1 hover:bg-secondary-second cursor-pointer ${isActive ? 'bg-secondary-first' : ''} ${
        isHighlighted ? '!bg-secondary-second' : ''
      } `}
    >
      {option.label}
    </li>
  );
};
